import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { SetIgVersionModalData } from './set.ig.version.modal.provider';

@Component({
  templateUrl: './set.ig.version.modal.component.html',
  styleUrls: ['./set.ig.version.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SetIgVersionModalComponent extends BaseComponent {
  public loading = false;
  public version = {
    event: {
      version: 'V2',
    },
    place: {
      version: 'V2',
    },
    tripPlanner: {
      version: 'V2',
    },
    clientDashboard: {
      version: 'V2',
    },
  };
  // public isAreaBusiness = false;
  public businessType = 'normal';
  public isUseIgDefaultCustomPlaceCategories = true;
  public showPlaceImageCount = 5;
  public initial = 'facebook';
  public googleKey = '';
  public blockCategories = '';
  public account: SetIgVersionModalData;
  public formGroup: FormGroup;

  constructor(
    private fb: FormBuilder,
    private accountApiService: AccountApiService,
    private alertify: AlertifyService,
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private dialogRef: MatDialogRef<SetIgVersionModalComponent>,
    data: SetIgVersionModalData
  ) {
    super();
    this.account = Object.assign({}, data);
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      googleKey: [null, null],
      blockCategories: [null, null],
    });

    this.loading = true;
    this.accountApiService.getIgVersion(this.account.account.userName).subscribe((version) => {
      if (version && version.event) {
        this.version = version;
      }
      this.loading = false;
    });
  }

  public setIgEventVersion() {
    this.accountApiService.setIgVersion(this.account.account.userName, this.version).subscribe((version) => {
      this.alertify.successfully('Set version');
    });
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/set.ig.version/set.ig.version.modal.component.ts